
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers/sandals",
      function () {
        return require("private-next-pages/sneakers/sandals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers/sandals"])
      });
    }
  